import useSWRImmutable from "swr/immutable";
import { Ads } from "../../../ads/Ads";
import RaceWidget from "../../../RaceWidget";
import { WidgetShare } from "../../../SocialButtons";
import { groupBy, stringToOrdinalNum } from "../../../../helpers/util";
import styles from "../../../../styles/races/local/parts/LocalContests.module.scss";
import Senatorial from "../../../SenatorialWidget";
import PartyList from "../../../partylist/PartyListWidget";

const cfUrl = process.env.API_CF_URL;
const basePath = process.env.SITE_URL;
const WidgetContainer = ({
  title,
  url,
  data,
  tooltipId,
  isMounted,
  containerStyle,
  iconsWrapper,
  btnStyle,
  children,
  isEmbed = false,
  slug = "",
}) => {
  return data !== undefined && data.length > 0 ? (
    <div className={styles.contestContainer}>
      <div className={styles.contestContainer_header}>
        <div className={styles.headerWrapper}>
          <h3 className={styles.title}>{title}</h3>
          <WidgetShare
            containerStyle={containerStyle}
            iconsWrapper={iconsWrapper}
            iconContainerStyle={btnStyle}
            url={url}
            tooltipId={`${tooltipId}_${slug}`}
            isMounted={isMounted}
            isEmbedShowed={!isEmbed}
            embedUrl={`${basePath}elections/2022/races/embed/local-place/${slug}`}
          />
        </div>
      </div>
      <div className={styles.candidatesContainer}>{children}</div>
    </div>
  ) : (
    ""
  );
};

const ProvincialContests = ({
  info,
  taguigLoneDistrict,
  isMounted,
  contests,
  presidential,
  vPresidential,
  senatorialList,
  partyList,
  allPartyList,
  children,
  regionList,
  view = "local-results",
  isEmbed = false,
}) => {
  const fetcher = (url, body) =>
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body,
    }).then(async (res) => {
      return res.json();
    });
  let urlPath = `${basePath}elections/2022/${info?.slug}`;
  let citySubText = info?.province
    ? `${info.display_name}, ${info?.province?.display_name}`
    : info.display_name;
  let isProvince = info?.province ? false : true;
  let mayorViceMayorDesc = {
    city: {
      mayorDesc:
        "This candidate is running for the position of City Mayor. The mayor is responsible for supervising all programs, projects, services, and activities of the city government, enforcing all laws and ordinances related to governance, maximizing the generation of resources and revenues, and ensuring the delivery of basic services and the provision of adequate facilities.",
      viceMayorDesc:
        "This candidate is running for the position of City Vice Mayor. The vice mayor is responsible for presiding over the sangguniang panlungsod (city council), signing all warrants for the expenditures of the city council, appointing officials and employees of the city council, exercising the powers and performing the duties and functions of the city mayor in cases of temporary vacancy, and assuming the office of mayor in the event of a permanent one.",
      readMore:
        "https://www.rappler.com/nation/elections/city-mayor-vice-councilor-philippines-powers-duties/",
    },
    municipal: {
      mayorDesc:
        "This candidate is running for the position of Municipal Mayor. The mayor is responsible for supervising all programs, projects, services, and activities of the municipal government, enforcing all laws and ordinances related to governance of the municipality and the exercise of its corporate powers, maximizing resource and revenue generation, and ensuring the delivery of basic services and the provision of adequate facilities.",
      viceMayorDesc:
        "This candidate is running for the position of Municipal Vice Mayor. The vice mayor is responsible for presiding over the sangguniang bayan (municipal council) and signing warrants for expenditures appropriated for its operation, appointing officials and employees of the sangguniang bayan, with exceptions provided in the Local Government Code, exercising the powers and perform the duties and functions of the municipal mayor in cases of temporary vacancy, and assuming the municipal mayor’s office in the event of a permanent one.",
      readMore:
        "https://www.rappler.com/nation/elections/municipal-mayor-vice-councilor-philippines-powers-duties/",
    },
  };

  let widgetCountForAds = 0;
  const widgetAdsThreshold = 4;

  const middle2 = (
    <Ads
      deviceType="mobile"
      id="ad-local-middle2-mobile"
      adType="middle2"
      pageType="elec_local_candidates"
    />
  );

  const { data: rawLatestResultsPHData, error: latestResultsPHError } =
    useSWRImmutable(
      [
        `${cfUrl}/latestTransmissionCount`,
        JSON.stringify({
          data: {
            locationSlug: info ? info?.slug : "philippines",
          },
        }),
      ],
      fetcher,
      {
        refreshInterval: 0,
        shouldRetryOnError: true,
        revalidateOnReconnect: true,
        refreshWhenOffline: true,
        errorRetryInterval: 5000,
        errorRetryCount: 1,
      }
    );
  const latestResultsPHData = rawLatestResultsPHData?.result;

  return (
    <div className={styles.mainContainer}>
      {children}
      {info?.legal_class !== "ICC" && (
        <WidgetContainer
          title="Governor and Vice Governor"
          url={urlPath}
          data={contests?.governor}
          tooltipId="tooltip_govAndVice"
          isMounted={isMounted}
          containerStyle={styles.localSocialsContainer}
          iconsWrapper={styles.localSocialsContainer_iconsWrapper}
          btnStyle={styles.img}
          isEmbed={isEmbed}
          slug={info?.slug}
        >
          <RaceWidget
            locSlug={info?.slug}
            withCollapse={false}
            candidatesList={contests?.governor}
            contestName="Governor"
            subText={info?.display_name}
            display={styles.remove}
            moreAboutText="more about the governor position"
            description="This candidate is running for the position of Governor. The governor is responsible for supervising the implementation of programs and projects carried out by the provincial government, overseeing the enforcement of laws and ordinances that affect the province, initiating and maximizing revenue generation for the province, initiating and maximizing the use of resources in the implementation of programs and projects for the benefit of his/her constituents, ensuring the delivery of basic services and the provision of adequate facilities for constituents, and overseeing the implementation of the provincial development plan."
            readMoreLink="https://www.rappler.com/nation/elections/provincial-governor-vice-board-member-philippines-powers-duties/"
            urlPath="/elections/2022/candidates/"
            url={urlPath}
            resetContainerMargin={true}
            regionList={regionList}
            view="local-results"
            raceName={contests?.governor[0]?.contest.name}
            precinctsLocal={info.precincts_count}
          />
          <RaceWidget
            locSlug={info?.slug}
            withCollapse={false}
            candidatesList={contests?.viceGovernor}
            contestName="Vice Governor"
            subText={info?.display_name}
            display={styles.remove}
            moreAboutText="more about the vice governor position"
            description="This candidate is running for the position of Vice Governor. The governor is responsible for serving as presiding officer of the sangguniang panlalawigan (provincial board), appointing all officials and employees of the sangguniang panlalawigan aside from those appointments prescribed in the Local Government Code of 1991, and taking over as governor for the remaining years in a term in the event of permanent vacancy, therefore exercising all powers and functions of the provincial chief executive."
            readMoreLink="https://www.rappler.com/nation/elections/provincial-governor-vice-board-member-philippines-powers-duties/"
            urlPath="/elections/2022/candidates/"
            url={urlPath}
            resetContainerMargin={true}
            regionList={regionList}
            view="local-results"
            raceName={contests?.viceGovernor[0]?.contest.name}
            precinctsLocal={info.precincts_count}
          />
        </WidgetContainer>
      )}
      <WidgetContainer
        title="Mayor and Vice Mayor"
        url={urlPath}
        data={contests?.mayor}
        tooltipId="tooltip_mayorAndVice"
        isMounted={isMounted}
        containerStyle={styles.localSocialsContainer}
        iconsWrapper={styles.localSocialsContainer_iconsWrapper}
        btnStyle={styles.img}
        isEmbed={isEmbed}
        slug={info?.slug}
      >
        <RaceWidget
          locSlug={info?.slug}
          withCollapse={false}
          candidatesList={contests?.mayor}
          contestName="Mayor"
          subText={citySubText}
          moreAboutText="more about the mayor position"
          display={styles.remove}
          regionList={regionList}
          view="local-results"
          raceName={info.contest_set[0].name}
          precinctsLocal={info.precincts_count}
          description={
            info?.administrative_type === "CITY"
              ? mayorViceMayorDesc.city.mayorDesc
              : mayorViceMayorDesc.municipal.mayorDesc
          }
          readMoreLink={
            info?.administrative_type === "CITY"
              ? mayorViceMayorDesc.city.readMore
              : mayorViceMayorDesc.municipal.readMore
          }
          urlPath="/elections/2022/candidates/"
          url={urlPath}
          resetContainerMargin={true}
          quote="Candidates for Mayor – 2022 Philippine elections #PHVote #WeDecide"
        />
        <RaceWidget
          locSlug={info?.slug}
          withCollapse={false}
          candidatesList={contests?.viceMayor}
          contestName="Vice Mayor"
          subText={citySubText}
          display={styles.remove}
          view="local-results"
          moreAboutText="more about the vice mayor position"
          regionList={regionList}
          raceName={info.contest_set[1].name}
          precinctsLocal={info.precincts_count}
          description={
            info?.administrative_type === "CITY"
              ? mayorViceMayorDesc.city.viceMayorDesc
              : mayorViceMayorDesc.municipal.viceMayorDesc
          }
          readMoreLink={
            info?.administrative_type === "CITY"
              ? mayorViceMayorDesc.city.readMore
              : mayorViceMayorDesc.municipal.readMore
          }
          urlPath="/elections/2022/candidates/"
          url={urlPath}
          resetContainerMargin={true}
          quote="Candidates for Vice Mayor – 2022 Philippine elections #PHVote #WeDecide"
        />
      </WidgetContainer>
      <div className={styles.adMiddle1}>
        <Ads
          deviceType="mobile"
          id="ad-local-middle1-mobile"
          adType="middle1"
          pageType="elec_local_candidates"
        />
      </div>
      <WidgetContainer
        title="Sangguniang Bayan"
        url={urlPath}
        data={contests.municipalCouncil}
        tooltipId="tooltip_mc"
        isMounted={isMounted}
        containerStyle={styles.localSocialsContainer}
        iconsWrapper={styles.localSocialsContainer_iconsWrapper}
        btnStyle={styles.img}
        isEmbed={isEmbed}
        slug={info?.slug}
      >
        {Object.keys(
          groupBy(contests.municipalCouncil, { root: "contest" }, "district")
        ).map((res, i) => {
          widgetCountForAds++;
          return (
            <>
              <RaceWidget
                key={i}
                locSlug={info?.slug}
                withCollapse={false}
                display={styles.remove}
                regionList={regionList}
                view="local-results"
                raceName={info.districts[i].contest_set[0].name}
                precinctsLocal={info.precincts_count}
                candidatesList={
                  groupBy(
                    contests.municipalCouncil,
                    { root: "contest" },
                    "district"
                  )[res]
                }
                contestName={`${
                  stringToOrdinalNum()[res.split(" ")[0]] !== undefined
                    ? stringToOrdinalNum()[res.split(" ")[0]]
                    : res.split(" ")[0].toLowerCase()
                } District`}
                moreAboutText="more about the sangguniang bayan position"
                subText={citySubText}
                description="This candidate is running for the position of Sangguniang Bayan (Municipal Council) member. A municipal council member is responsible for approving ordinances and passing resolutions for an efficient and effective municipal government, generating and maximizing resources and revenues for the municipality’s development plans, program objectives, and priorities, granting franchises, enacting ordinances authorizing the issuance of permits or licenses, enacting ordinances levying taxes, fees, and charges, regulating activities related to the use of land, buildings, and structures within the municipality, and approving ordinances ensuring the efficient and effective delivery of basic services and facilities."
                readMoreLink="https://www.rappler.com/nation/elections/municipal-mayor-vice-councilor-philippines-powers-duties/"
                urlPath="/elections/2022/candidates/"
                url={urlPath}
                resetContainerMargin={true}
              />
              {widgetCountForAds === widgetAdsThreshold && middle2}
            </>
          );
        })}
      </WidgetContainer>
      <WidgetContainer
        title="Sangguniang Panlungsod"
        url={urlPath}
        data={contests.cityCouncil}
        tooltipId="tooltip_mc"
        isMounted={isMounted}
        containerStyle={styles.localSocialsContainer}
        iconsWrapper={styles.localSocialsContainer_iconsWrapper}
        btnStyle={styles.img}
        isEmbed={isEmbed}
        slug={info?.slug}
      >
        {Object.keys(
          groupBy(contests.cityCouncil, { root: "contest" }, "name")
        ).map((res, i) => {
          widgetCountForAds++;

          return (
            <>
              <RaceWidget
                key={i}
                locSlug={info?.slug}
                withCollapse={false}
                display={styles.remove}
                regionList={regionList}
                view="local-results"
                raceName={res}
                precinctsLocal={info.precincts_count}
                candidatesList={
                  groupBy(contests.cityCouncil, { root: "contest" }, "name")[
                    res
                  ]
                }
                contestName={res
                  .split(" ")
                  .splice(-2)
                  .join(" ")
                  .replace("DIST", "DISTRICT")}
                moreAboutText="more about the sangguniang panlungsod position"
                subText={citySubText}
                description="This candidate is running for the position of Sangguniang Panlungsod (City Council) Member. A city council member is responsible for approving ordinances and passing resolutions for an effective city government, generating resources and revenues for the city’s development plans, program objectives, and priorities, enacting ordinances that grant franchises and authorizing the issuance of permits or licenses, regulating activities in relation to the use of land, buildings, and structures, and approving ordinances for the delivery of basic services and facilities."
                readMoreLink="https://www.rappler.com/nation/elections/city-mayor-vice-councilor-philippines-powers-duties/"
                urlPath="/elections/2022/candidates/"
                url={urlPath}
                resetContainerMargin={true}
              />
              {widgetCountForAds === widgetAdsThreshold && middle2}
            </>
          );
        })}
      </WidgetContainer>
      <WidgetContainer
        title="Sangguniang Panlalawigan"
        url={urlPath}
        data={contests.provBoard}
        tooltipId="tooltip_lalawigan"
        isMounted={isMounted}
        containerStyle={styles.localSocialsContainer}
        iconsWrapper={styles.localSocialsContainer_iconsWrapper}
        btnStyle={styles.img}
        isEmbed={isEmbed}
        slug={info?.slug}
      >
        {Object.keys(
          groupBy(contests.provBoard, { root: "contest" }, "name")
        ).map((res, i) => {
          widgetCountForAds++;
          return (
            <>
              <RaceWidget
                key={i}
                locSlug={info?.slug}
                withCollapse={false}
                display={styles.remove}
                regionList={regionList}
                view="local-results"
                raceName={res}
                precinctsLocal={info.precincts_count}
                candidatesList={
                  groupBy(contests.provBoard, { root: "contest" }, "name")[res]
                }
                contestName={res.split("-")[1]}
                moreAboutText="more about the sangguniang panlalawigan position"
                subText={info?.display_name}
                description="This candidate is running for the position of Sangguniang Panlalawigan (Provincial Board) Member. A provincial board member is responsible for enacting ordinances and resolutions to appropriate funds for the programs and projects of the province, enacting annual and supplemental appropriations of the provincial government, approving and passing ordinances and resolutions necessary for the function of the provincial government, granting franchises, and approving permits and licenses."
                readMoreLink="https://www.rappler.com/nation/elections/provincial-governor-vice-board-member-philippines-powers-duties/"
                urlPath="/elections/2022/candidates/"
                url={urlPath}
                resetContainerMargin={true}
              />
              {widgetCountForAds === widgetAdsThreshold && middle2}
            </>
          );
        })}
      </WidgetContainer>
      <WidgetContainer
        title="House of Representatives"
        url={urlPath}
        data={taguigLoneDistrict ? taguigLoneDistrict : contests.houseOfRep}
        tooltipId="tooltip_hor"
        isMounted={isMounted}
        containerStyle={styles.localSocialsContainer}
        iconsWrapper={styles.localSocialsContainer_iconsWrapper}
        btnStyle={styles.img}
        isEmbed={isEmbed}
        slug={info?.slug}
      >
        {Object.keys(
          groupBy(contests.houseOfRep, { root: "contest" }, "name")
        ).map((res, i) => {
          widgetCountForAds++;

          return (
            <>
              <RaceWidget
                key={i}
                locSlug={info?.slug}
                withCollapse={false}
                display={styles.remove}
                regionList={regionList}
                view="local-results"
                raceName={res}
                precinctsLocal={info.precincts_count}
                candidatesList={
                  groupBy(contests.houseOfRep, { root: "contest" }, "name")[res]
                }
                contestName={res.split("-")[1]}
                moreAboutText="more about the house of representatives position"
                subText={citySubText}
                description="This candidate is running to represent their district in Congress. A member of the House of Representatives is responsible for creating bills and resolutions, reviewing the budget proposed by the executive department and create the general appropriations (budget) bill, tackling impeachment complaints and submitting the resolution setting the Articles of Impeachment, voting to declare the existence of a state of war, authorizing the president to exercise powers to carry out a declared national policy in times of war or other national emergency, voting to revoke or extend the president’s proclamation of martial law, through the Commission on Appointments, approving or rejecting key appointments made by the president to government agencies, voting on the president’s grant of amnesty, proposing amendments and revisions to the Constitution, and voting to convene into a constituent assembly or to call for an election of members of a constitutional convention."
                readMoreLink="https://www.rappler.com/nation/elections/provincial-governor-vice-board-member-philippines-powers-duties/"
                urlPath="/elections/2022/candidates/"
                url={urlPath}
                resetContainerMargin={true}
              />
              {widgetCountForAds === widgetAdsThreshold && middle2}
            </>
          );
        })}
        {taguigLoneDistrict && (
          <>
            {taguigLoneDistrict?.map((res, i) => {
              widgetCountForAds++;

              return (
                <>
                  <RaceWidget
                    key={i}
                    locSlug={info?.slug}
                    withCollapse={false}
                    display={styles.remove}
                    candidatesList={res.results}
                    regionList={regionList}
                    view="local-results"
                    raceName={res.results[1].contest.name}
                    precinctsLocal={info.precincts_count}
                    contestName={`Lone Legislative District`}
                    moreAboutText="more about the house of representatives position"
                    subText={
                      info?.slug === "ncr-pateros" || i === 0
                        ? "NCR, Taguig City (1ST Councilor district) - Pateros"
                        : "NCR, Taguig City (2nd Councilor district)"
                    }
                    description="This candidate is running for the position of Sangguniang Panlalawigan (Provincial Board) Member. A provincial board member is responsible for enacting ordinances and resolutions to appropriate funds for the programs and projects of the province, enacting annual and supplemental appropriations of the provincial government, approving and passing ordinances and resolutions necessary for the function of the provincial government, granting franchises, and approving permits and licenses."
                    readMoreLink="https://www.rappler.com/nation/elections/provincial-governor-vice-board-member-philippines-powers-duties/"
                    urlPath="/elections/2022/candidates/"
                    url={urlPath}
                    resetContainerMargin={true}
                  />
                  {widgetCountForAds === widgetAdsThreshold && middle2}
                </>
              );
            })}
          </>
        )}
      </WidgetContainer>
      <WidgetContainer
        title="President and Vice President"
        url={urlPath}
        data={presidential?.results}
        tooltipId="tooltip_sen"
        isMounted={isMounted}
        containerStyle={styles.localSocialsContainer}
        iconsWrapper={styles.localSocialsContainer_iconsWrapper}
        btnStyle={styles.img}
        isEmbed={isEmbed}
        slug={info?.slug}
      >
        <RaceWidget
          locSlug={info?.slug}
          withCollapse={false}
          candidatesList={presidential?.results}
          contestName="presidential race"
          subText={citySubText}
          display={styles.remove}
          description="The winner will become the 17th president of the Philippines, to serve for six years starting noon of June 30, 2022. "
          readMoreLink="https://www.rappler.com/nation/elections/president-vp-philippines-powers-duties/"
          urlPath="/elections/2022/candidates/"
          url={urlPath}
          resetContainerMargin={true}
          regionList={regionList}
          view="local-results"
          raceName="PRESIDENT PHILIPPINES"
          precinctsLocal={info.precincts_count}
          isProvince={isProvince}
        />
        <RaceWidget
          locSlug={info?.slug}
          withCollapse={false}
          candidatesList={vPresidential?.results}
          contestName="vice presidential race"
          subText={citySubText}
          display={styles.remove}
          description="The winner will become the 15th vice president of the Philippines, to serve for six years, starting noon of June 30, 2022. "
          readMoreLink="https://www.rappler.com/nation/elections/president-vp-philippines-powers-duties/"
          urlPath="/elections/2022/candidates/"
          url={urlPath}
          resetContainerMargin={true}
          regionList={regionList}
          view="local-results"
          raceName="VICE PRESIDENT PHILIPPINES"
          precinctsLocal={info.precincts_count}
          isProvince={isProvince}
        />
      </WidgetContainer>
      <WidgetContainer
        title="Senator"
        url={urlPath}
        data={senatorialList?.results}
        tooltipId="tooltip_sen"
        isMounted={isMounted}
        containerStyle={styles.localSocialsContainer}
        iconsWrapper={styles.localSocialsContainer_iconsWrapper}
        btnStyle={styles.img}
        isEmbed={isEmbed}
        slug={info?.slug}
      >
        <div className={styles.nationalRaceWrapper}>
          <Senatorial
            view={view}
            withCollapse={false}
            regionList={regionList}
            senatorialList={senatorialList}
            subText={citySubText}
            urlPath="/elections/2022/candidates/"
            url={urlPath}
            resetWrapper={true}
            columnsCount={1}
            limit={12}
            withResultsFooter={false}
            locSlug={info?.slug}
            precinctsLocal={info.precincts_count}
            isProvince={isProvince}
          />
        </div>
      </WidgetContainer>
      <WidgetContainer
        title="Party-list "
        url={urlPath}
        data={allPartyList?.results}
        tooltipId="tooltip_sen"
        isMounted={isMounted}
        containerStyle={styles.localSocialsContainer}
        iconsWrapper={styles.localSocialsContainer_iconsWrapper}
        btnStyle={styles.img}
        isEmbed={isEmbed}
        slug={info?.slug}
      >
        <div className={styles.nationalRaceWrapper}>
          <PartyList
            raceName="PARTY LIST PHILIPPINES"
            minified={true}
            regionList={regionList}
            view="local-results"
            partyList={partyList}
            subText={citySubText}
            allPartyList={allPartyList}
            url={urlPath}
            viewAllLink={`${urlPath}elections/2022/races/party-list/results`}
            withResultsFooter={false}
            resetWrapper={true}
            miniPagination={true}
            locSlug={info?.slug}
            precinctsLocal={info.precincts_count}
            isProvince={isProvince}
          />
        </div>
      </WidgetContainer>
    </div>
  );
};

export default ProvincialContests;
